/* ============================================================
   SAMVI Factory — theme.js  (vanilla, modular, no framework)
   ============================================================ */
(function () {
  'use strict';

  const routes = window.themeRoutes || {};
  const strings = window.themeStrings || {};
  const money = (cents) => {
    if (window.Shopify && window.Shopify.formatMoney && window.themeMoneyFormat) {
      return window.Shopify.formatMoney(cents, window.themeMoneyFormat);
    }
    return 'CHF ' + (cents / 100).toFixed(2);
  };

  const on = (el, evt, sel, fn) => {
    el.addEventListener(evt, (e) => {
      const target = e.target.closest(sel);
      if (target && el.contains(target)) fn(e, target);
    });
  };
  const fetchJSON = (url, opts) =>
    fetch(url, Object.assign({ headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }, opts)).then((r) => r.json());

  /* ---------------- Overlay helper (focus trap + esc) ---------------- */
  function makeToggleable(root, openClass) {
    openClass = openClass || 'is-open';
    let lastFocus = null;
    const open = () => {
      lastFocus = document.activeElement;
      root.classList.add(openClass);
      document.body.style.overflow = 'hidden';
      const focusable = root.querySelector('[autofocus], input, button, a[href]');
      if (focusable) setTimeout(() => focusable.focus(), 60);
      document.addEventListener('keydown', onKey);
    };
    const close = () => {
      root.classList.remove(openClass);
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKey);
      if (lastFocus) lastFocus.focus();
    };
    const onKey = (e) => { if (e.key === 'Escape') close(); };
    return { open, close };
  }

  /* ---------------- Mobile menu ---------------- */
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  if (mobileMenu) {
    const ctrl = makeToggleable(mobileMenu);
    document.querySelectorAll('[data-mobile-menu-open]').forEach((b) => b.addEventListener('click', ctrl.open));
    mobileMenu.querySelectorAll('[data-menu-close], .mobile-menu__overlay').forEach((b) => b.addEventListener('click', ctrl.close));
  }

  /* ---------------- Search modal + predictive ---------------- */
  const searchModal = document.querySelector('[data-search-modal]');
  if (searchModal) {
    const ctrl = makeToggleable(searchModal);
    document.querySelectorAll('[data-search-open]').forEach((b) => b.addEventListener('click', ctrl.open));
    searchModal.querySelectorAll('[data-search-close], .search-modal__overlay').forEach((b) => b.addEventListener('click', ctrl.close));

    const input = searchModal.querySelector('input[type="search"]');
    const results = searchModal.querySelector('[data-predictive-results]');
    if (input && results && searchModal.dataset.predictive === 'true') {
      let t;
      input.addEventListener('input', () => {
        clearTimeout(t);
        const q = input.value.trim();
        if (q.length < 2) { results.innerHTML = ''; return; }
        t = setTimeout(() => runPredictive(q, results), 220);
      });
    }
  }

  function runPredictive(q, container) {
    const url = (routes.predictive_search_url || '/search/suggest') +
      '?q=' + encodeURIComponent(q) +
      '&resources[type]=product,collection,page&resources[limit]=6&section_id=predictive-search';
    fetch(url)
      .then((r) => r.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const inner = doc.querySelector('[data-predictive-results]');
        container.innerHTML = inner ? inner.innerHTML : '';
      })
      .catch(() => {});
  }

  /* ---------------- Cart drawer ---------------- */
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const drawerCtrl = cartDrawer ? makeToggleable(cartDrawer) : null;
  // Delegated close — the drawer's inner content is replaced on cart updates,
  // so its close button must survive re-renders.
  if (cartDrawer && drawerCtrl) {
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-cart-close]')) drawerCtrl.close();
    });
  }
  document.querySelectorAll('[data-cart-open]').forEach((b) =>
    b.addEventListener('click', (e) => {
      if (cartDrawer && drawerCtrl) { e.preventDefault(); drawerCtrl.open(); }
    })
  );

  function refreshCartUI(cart) {
    // bubble counts
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
    // re-render drawer + count sections
    const sectionsToRender = [];
    if (cartDrawer) sectionsToRender.push('cart-drawer');
    if (document.querySelector('[data-cart-page]')) sectionsToRender.push('main-cart');
    if (!sectionsToRender.length) return;
    fetch('/?sections=' + sectionsToRender.join(','))
      .then((r) => r.json())
      .then((data) => {
        sectionsToRender.forEach((id) => {
          if (!data[id]) return;
          const doc = new DOMParser().parseFromString(data[id], 'text/html');
          const src = doc.querySelector('[data-section-content]');
          const dest = document.querySelector('[data-section-id="' + id + '"] [data-section-content]');
          if (src && dest) dest.innerHTML = src.innerHTML;
        });
      });
  }

  function addToCart(form, btn) {
    const formData = new FormData(form);
    if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
    fetch(routes.cart_add_url || '/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/javascript' },
      body: formData,
    })
      .then((r) => r.json())
      .then((res) => {
        if (res.status) { showFormError(form, res.description || res.message); return; }
        return fetchJSON(routes.cart_url ? routes.cart_url + '.js' : '/cart.js');
      })
      .then((cart) => {
        if (!cart) return;
        refreshCartUI(cart);
        if (drawerCtrl) drawerCtrl.open();
      })
      .catch(() => {})
      .finally(() => { if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; } });
  }

  function showFormError(form, msg) {
    let box = form.querySelector('[data-form-error]');
    if (!box) {
      box = document.createElement('div');
      box.setAttribute('data-form-error', '');
      box.className = 'form-status form-status--error';
      form.appendChild(box);
    }
    box.textContent = msg || strings.cartError || 'Etwas ist schiefgelaufen.';
  }

  // Add-to-cart forms (product + quick)
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[action$="/cart/add"], form[data-add-to-cart]');
    if (!form) return;
    e.preventDefault();
    addToCart(form, form.querySelector('[type="submit"], [data-add-button]'));
  });

  // Line item quantity + remove (delegated across drawer and cart page)
  function changeLine(line, quantity) {
    return fetchJSON(routes.cart_change_url || '/cart/change.js', {
      method: 'POST',
      body: JSON.stringify({ line: line, quantity: quantity }),
    }).then((cart) => { refreshCartUI(cart); return cart; });
  }
  document.addEventListener('click', (e) => {
    const stepper = e.target.closest('[data-qty-change]');
    if (stepper) {
      const wrap = stepper.closest('[data-qty]');
      const input = wrap ? wrap.querySelector('input') : null;
      if (!input) return;
      let val = parseInt(input.value, 10) || 1;
      val += stepper.dataset.qtyChange === 'up' ? 1 : -1;
      val = Math.max(parseInt(input.min || '1', 10), val);
      input.value = val;
      // Fire a single change event; the change handler performs the cart update
      // (product page has no data-line, so nothing happens there — correct).
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    const removeBtn = e.target.closest('[data-cart-remove]');
    if (removeBtn) {
      e.preventDefault();
      const line = removeBtn.closest('[data-line]');
      if (line) changeLine(parseInt(line.dataset.line, 10), 0);
    }
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-line] input[data-qty-input]');
    if (!input) return;
    const wrap = input.closest('[data-line]');
    changeLine(parseInt(wrap.dataset.line, 10), Math.max(0, parseInt(input.value, 10) || 0));
  });

  /* ---------------- Product: variants, gallery, sticky ATC ---------------- */
  document.querySelectorAll('[data-product-form-container]').forEach(initProduct);

  function initProduct(container) {
    const dataEl = container.querySelector('[data-product-json]');
    if (!dataEl) return;
    let product;
    try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }
    const form = container.querySelector('form[data-add-to-cart], form[action$="/cart/add"]');
    const idInput = form ? form.querySelector('[name="id"]') : null;
    const priceEl = container.querySelector('[data-product-price]');
    const btnText = container.querySelector('[data-add-button] [data-add-price], [data-add-button]');
    const optionInputs = container.querySelectorAll('[data-option-selector]');

    function currentOptions() {
      const opts = [];
      optionInputs.forEach((group) => {
        const checked = group.querySelector('input:checked, option:checked, select');
        if (group.tagName === 'SELECT') { opts[parseInt(group.dataset.optionIndex, 10)] = group.value; return; }
        const sel = group.querySelector('input:checked');
        if (sel) opts[parseInt(group.dataset.optionIndex, 10)] = sel.value;
      });
      return opts;
    }

    function findVariant(opts) {
      return product.variants.find((v) => v.options.every((o, i) => o === opts[i]));
    }

    function update() {
      const opts = currentOptions();
      const variant = findVariant(opts);
      // reflect active state on option labels (covers browsers without :has())
      optionInputs.forEach((group) => {
        group.querySelectorAll('label').forEach((label) => {
          const input = label.querySelector('input');
          if (input) label.classList.toggle('is-active', input.checked);
        });
      });
      // update selected labels
      container.querySelectorAll('[data-selected-value]').forEach((el) => {
        const idx = parseInt(el.dataset.selectedValue, 10);
        if (opts[idx]) el.textContent = opts[idx];
      });
      if (!variant) {
        if (idInput) idInput.value = '';
        if (form) { const b = form.querySelector('[data-add-button]'); if (b) { b.disabled = true; b.querySelector('[data-add-label]') && (b.querySelector('[data-add-label]').textContent = strings.unavailable || 'Nicht verfügbar'); } }
        return;
      }
      if (idInput) idInput.value = variant.id;
      const url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
      if (priceEl) priceEl.innerHTML = money(variant.price);
      const addLabel = container.querySelector('[data-add-label]');
      const addBtn = container.querySelector('[data-add-button]');
      if (addBtn) addBtn.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? (strings.addToCart || 'In den Warenkorb') : (strings.soldOut || 'Ausverkauft');
      const addPrice = container.querySelector('[data-add-price]');
      if (addPrice) addPrice.innerHTML = variant.available ? ' · ' + money(variant.price) : '';
      // sticky
      const stickyPrice = container.querySelector('[data-sticky-price]');
      if (stickyPrice) stickyPrice.innerHTML = money(variant.price);
      // swap gallery to the selected variant's image
      updateGallery(variant);
    }

    // Gallery — defined before the initial update() so variant changes can swap the image
    const mainMedia = container.querySelector('[data-gallery-main]');
    function applyThumb(thumb) {
      const src = thumb.dataset.mediaSrc;
      const srcset = thumb.dataset.mediaSrcset;
      if (mainMedia && src) {
        const img = mainMedia.querySelector('img');
        if (img) { img.src = src; if (srcset) img.srcset = srcset; }
      }
      container.querySelectorAll('[data-gallery-thumb]').forEach((t) => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
    }
    function updateGallery(variant) {
      if (!variant || !mainMedia) return;
      const mediaId = variant.featured_media && variant.featured_media.id;
      if (mediaId) {
        const thumb = container.querySelector('[data-gallery-thumb][data-media-id="' + mediaId + '"]');
        if (thumb) { applyThumb(thumb); return; }
      }
      // fallback: variant image not among the thumbnails
      const fimg = variant.featured_image;
      if (fimg && fimg.src) {
        const img = mainMedia.querySelector('img');
        if (img) {
          let s = fimg.src;
          s += (s.indexOf('?') > -1 ? '&' : '?') + 'width=1000';
          img.src = s;
          img.removeAttribute('srcset');
          if (fimg.alt) img.alt = fimg.alt;
        }
        container.querySelectorAll('[data-gallery-thumb]').forEach((t) => t.classList.remove('is-active'));
      }
    }
    on(container, 'click', '[data-gallery-thumb]', (e, thumb) => applyThumb(thumb));

    optionInputs.forEach((group) => group.addEventListener('change', update));
    update();

    // Sticky ATC visibility
    const sticky = container.querySelector('[data-sticky-atc]');
    const anchor = container.querySelector('[data-atc-anchor]');
    if (sticky && anchor && 'IntersectionObserver' in window) {
      const obs = new IntersectionObserver(
        (entries) => { entries.forEach((en) => sticky.classList.toggle('is-visible', !en.isIntersecting)); },
        { rootMargin: '0px 0px -80px 0px' }
      );
      obs.observe(anchor);
    }
  }

  /* ---------------- Filters (mobile toggle) ---------------- */
  document.querySelectorAll('[data-filters-toggle]').forEach((btn) =>
    btn.addEventListener('click', () => {
      const panel = document.querySelector('[data-filters]');
      if (panel) panel.classList.toggle('is-open');
    })
  );
  // auto-submit sort + filters
  document.querySelectorAll('[data-auto-submit]').forEach((el) =>
    el.addEventListener('change', () => el.closest('form') && el.closest('form').submit())
  );

  /* ---------------- Legal TOC scroll-spy ---------------- */
  const toc = document.querySelector('[data-legal-toc]');
  if (toc && 'IntersectionObserver' in window) {
    const links = toc.querySelectorAll('a');
    const map = {};
    links.forEach((l) => { const id = l.getAttribute('href').slice(1); const t = document.getElementById(id); if (t) map[id] = l; });
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((en) => {
          if (en.isIntersecting) {
            links.forEach((l) => l.classList.remove('is-active'));
            if (map[en.target.id]) map[en.target.id].classList.add('is-active');
          }
        });
      },
      { rootMargin: '-20% 0px -70% 0px' }
    );
    Object.keys(map).forEach((id) => obs.observe(document.getElementById(id)));
  }

  /* ---------------- Gift card view: copy code + print ---------------- */
  document.querySelectorAll('[data-copy-code]').forEach((btn) =>
    btn.addEventListener('click', () => {
      const code = btn.dataset.copyCode;
      if (navigator.clipboard && code) {
        navigator.clipboard.writeText(code).then(() => {
          const orig = btn.textContent;
          btn.textContent = strings.copied || 'Kopiert ✓';
          setTimeout(() => (btn.textContent = orig), 1600);
        });
      }
    })
  );
  document.querySelectorAll('[data-print]').forEach((btn) => btn.addEventListener('click', () => window.print()));

  /* ---------------- Newsletter / contact form status scroll ---------------- */
  const params = new URLSearchParams(window.location.search);
  if (params.get('customer_posted') === 'true' || params.get('contact_posted') === 'true') {
    const success = document.querySelector('.form-status--success');
    if (success) success.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
})();
